export const INITIATED = 'INITIATED'
export const REGISTER_FAILED = 'REGISTER_FAILED'
export const LOGIN_FAILED = 'LOGIN_FAILED'
export const ACCOUNT_CHANGED = 'ACCOUNT_CHANGED'

export const ACCEPT_TOS_SUCCESS = 'ACCEPT_TOS_SUCCESS'
export const ACCEPT_TOS_FAILED = 'ACCEPT_TOS_FAILED'

export const YES_FLOW_FAILED = 'YES_FLOW_FAILED'

export const DOC_SCAN_SESSION_WAITING = 'DOC_SCAN_SESSION_WAITING'
export const DOC_SCAN_OUTCOME_REASON = 'DOC_SCAN_OUTCOME_REASON'
export const SESSION_EXPIRED = 'SESSION_EXPIRED'

export const ALERT_ADDED = 'ALERT_ADDED'
export const ALERT_DISMISSED = 'ALERT_DISMISSED'
export const ALERT_REMOVED = 'ALERT_REMOVED'
export const ALERTS_DISMISSED = 'ALERTS_DISMISSED'
export const ALERTS_REMOVED = 'ALERTS_REMOVED'

export const EMAIL_VERIFIED_SUCCESS = 'EMAIL_VERIFIED_SUCCESS'
export const EMAIL_VERIFIED_FAILED = 'EMAIL_VERIFIED_FAILED'

export const PROFILE_UPDATED = 'PROFILE_UPDATED'

export const YOTI_FLOW_FAILED = 'YOTI_FLOW_FAILED'

export const ERROR_OCCURRED = 'ERROR_OCCURRED'

export const DISCONNECTED = 'DISCONNECTED'
